import { Feedback } from '../Feedback';

export function ClaimsDeadlineMissedFeedback() {
  return (
    <Feedback
      type="warning"
      title="Your application is no longer eligible for funding."
      icon="checkCircle"
    >
      <p>
        The deadline to upload your contract has passed. Your application is no
        longer eligible, and the approved funding has been reallocated back into
        the fund.
      </p>
    </Feedback>
  );
}
